import React, { useState } from 'react';

export interface IysIzinDetay {
    iysIzinID: number;
    iletisimTipi: string;
    iletisimVerisi: string;
    izinDurumu: string;
    onayYontemi: string;
    evrakYolu: string | null;
    islemTarihi: string;
    ekleyenAdi: string | null;
    aktifMi: boolean;
}

interface IysKayitListesiProps {
    izinler: IysIzinDetay[];
}

const iletisimTipiLabel: Record<string, string> = {
    TELEFON1: 'Telefon 1',
    TELEFON2: 'Telefon 2',
    EPOSTA: 'E-Posta',
};

const yontemLabel: Record<string, string> = {
    SMS_KOD: 'SMS Doğrulama',
    WEB_FORM: 'Web Formu / Beyan',
    YAZILI_BELGE: 'Yazılı Belge',
    EPOSTA_KOD: 'E-posta Doğrulama',
};

const yontemIcon: Record<string, string> = {
    SMS_KOD: 'fa-sms',
    WEB_FORM: 'fa-file-alt',
    YAZILI_BELGE: 'fa-file-signature',
    EPOSTA_KOD: 'fa-envelope',
};

const IysKayitListesi: React.FC<IysKayitListesiProps> = ({ izinler }) => {
    const [belgeModal, setBelgeModal] = useState<string | null>(null);
    const [acik, setAcik] = useState(false);

    if (izinler.length === 0) return null;

    return (
        <>
            <div style={{ marginTop: 16, marginBottom: 4, border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                <button
                    type="button"
                    onClick={() => setAcik(p => !p)}
                    style={{
                        width: '100%', display: 'flex', alignItems: 'center', gap: 8,
                        padding: '10px 14px', background: acik ? '#fff7ed' : '#f9fafb',
                        border: 'none', borderBottom: acik ? '1px solid #e5e7eb' : 'none',
                        cursor: 'pointer', textAlign: 'left'
                    }}
                >
                    <i className="fas fa-shield-alt" style={{ color: '#e67d21', fontSize: 14 }}></i>
                    <span style={{ fontWeight: 600, fontSize: 13, color: '#374151', flex: 1 }}>IYS İzin Kayıtları</span>
                    <span style={{
                        background: '#e67d21', color: '#fff', borderRadius: 10,
                        padding: '1px 7px', fontSize: 11, fontWeight: 700, marginRight: 6
                    }}>{izinler.length}</span>
                    <i className={`fas fa-chevron-${acik ? 'up' : 'down'}`} style={{ color: '#9ca3af', fontSize: 12 }}></i>
                </button>

                {acik && <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '10px 10px 10px' }}>
                    {izinler.map(iz => (
                        <div key={iz.iysIzinID} style={{
                            border: `1px solid ${iz.aktifMi ? (iz.izinDurumu === 'ONAY' ? '#86efac' : '#fca5a5') : '#e5e7eb'}`,
                            borderLeft: `3px solid ${iz.aktifMi ? (iz.izinDurumu === 'ONAY' ? '#22c55e' : '#ef4444') : '#9ca3af'}`,
                            borderRadius: 6, padding: '8px 12px',
                            background: iz.aktifMi ? (iz.izinDurumu === 'ONAY' ? '#f0fdf4' : '#fff5f5') : '#f9fafb',
                            fontSize: 13, opacity: iz.aktifMi ? 1 : 0.65
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                                {/* Sol: Tip + Değer + Yöntem */}
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3 }}>
                                        <span style={{
                                            background: '#1a2440', color: '#fff',
                                            borderRadius: 4, padding: '1px 6px', fontSize: 11, fontWeight: 600
                                        }}>
                                            {iletisimTipiLabel[iz.iletisimTipi] ?? iz.iletisimTipi}
                                        </span>
                                        <span style={{ color: '#111827', fontWeight: 500 }}>{iz.iletisimVerisi}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#6b7280' }}>
                                        <i className={`fas ${yontemIcon[iz.onayYontemi] ?? 'fa-check'}`} style={{ fontSize: 12 }}></i>
                                        <span>{yontemLabel[iz.onayYontemi] ?? iz.onayYontemi}</span>
                                    </div>
                                </div>

                                {/* Sağ: Tarih + Ekleyen + Durum */}
                                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                    <div style={{ marginBottom: 3 }}>
                                        <span style={{
                                            background: iz.aktifMi ? (iz.izinDurumu === 'ONAY' ? '#22c55e' : '#ef4444') : '#9ca3af',
                                            color: '#fff', borderRadius: 4, padding: '1px 7px', fontSize: 11, fontWeight: 600
                                        }}>
                                            {!iz.aktifMi ? '⊘ Pasif' : iz.izinDurumu === 'ONAY' ? '✓ Onaylı' : '✗ Ret'}
                                        </span>
                                    </div>
                                    <div style={{ color: '#6b7280', fontSize: 12 }}>
                                        {new Date(iz.islemTarihi).toLocaleDateString('tr-TR', {
                                            day: '2-digit', month: '2-digit', year: 'numeric'
                                        })}
                                        {' '}
                                        {new Date(iz.islemTarihi).toLocaleTimeString('tr-TR', {
                                            hour: '2-digit', minute: '2-digit'
                                        })}
                                    </div>
                                    {iz.ekleyenAdi && (
                                        <div style={{ color: '#9ca3af', fontSize: 11, marginTop: 2 }}>
                                            <i className="fas fa-user" style={{ marginRight: 3 }}></i>
                                            {iz.ekleyenAdi}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Belge görüntüleme butonu */}
                            {iz.evrakYolu && (
                                <div style={{ marginTop: 6, paddingTop: 6, borderTop: '1px dashed #bbf7d0' }}>
                                    <button
                                        type="button"
                                        onClick={() => setBelgeModal(`http://localhost:5159${iz.evrakYolu}`)}
                                        style={{
                                            background: 'none', border: '1px solid #16a34a', color: '#16a34a',
                                            borderRadius: 4, padding: '2px 10px', cursor: 'pointer', fontSize: 12
                                        }}>
                                        <i className="fas fa-eye" style={{ marginRight: 5 }}></i>Belgeyi Görüntüle
                                    </button>
                                    <a
                                        href={`http://localhost:5159${iz.evrakYolu}`}
                                        target="_blank" rel="noreferrer"
                                        style={{
                                            marginLeft: 8, color: '#4b5563', fontSize: 12,
                                            textDecoration: 'none'
                                        }}>
                                        <i className="fas fa-external-link-alt" style={{ marginRight: 4 }}></i>Yeni sekmede aç
                                    </a>
                                </div>
                            )}
                        </div>
                    ))}
                    </div>
                }
            </div>

            {/* Belge Görüntüleme Modal */}
            {belgeModal && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)',
                    zIndex: 11000, display: 'flex', alignItems: 'center', justifyContent: 'center'
                }} onClick={() => setBelgeModal(null)}>
                    <div style={{
                        background: '#fff', borderRadius: 8, width: '80vw', maxWidth: 900,
                        height: '85vh', display: 'flex', flexDirection: 'column', overflow: 'hidden'
                    }} onClick={e => e.stopPropagation()}>
                        <div style={{
                            padding: '12px 16px', borderBottom: '1px solid #e5e7eb',
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                        }}>
                            <span style={{ fontWeight: 600, color: '#1a2440' }}>
                                <i className="fas fa-file-signature" style={{ marginRight: 8, color: '#e67d21' }}></i>
                                IYS Evrakı
                            </span>
                            <button onClick={() => setBelgeModal(null)} style={{
                                background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#666'
                            }}>×</button>
                        </div>
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                            {belgeModal.match(/\.(jpg|jpeg|png)$/i)
                                ? <img src={belgeModal} alt="evrak" style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 16 }} />
                                : <iframe src={belgeModal} title="evrak" style={{ width: '100%', height: '100%', border: 'none' }} />
                            }
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default IysKayitListesi;
